var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveItemBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71429 0C3.85 0 3.14286 0.61875 3.14286 1.375H1.57143C0.707143 1.375 0 1.99375 0 2.75H11C11 1.99375 10.2929 1.375 9.42857 1.375H7.85714C7.85714 0.61875 7.15 0 6.28571 0H4.71429ZM1.57143 4.125V10.7387C1.57143 10.89 1.69714 11 1.87 11H9.14571C9.31857 11 9.44429 10.89 9.44429 10.7387V4.125H7.87286V8.9375C7.87286 9.3225 7.52714 9.625 7.08714 9.625C6.64714 9.625 6.30143 9.3225 6.30143 8.9375V4.125H4.73V8.9375C4.73 9.3225 4.38429 9.625 3.94429 9.625C3.50429 9.625 3.15857 9.3225 3.15857 8.9375V4.125H1.58714H1.57143Z",
    fill: "#7D94AE",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveItemBlue);
export default __webpack_public_path__ + "static/media/remove-item-blue.515670d8ec61e5a62d0a597e9dfe0fed.svg";
export { ForwardRef as ReactComponent };